import { cloneDeep } from '../dependencies/nodash/cloneDeep';

/**
 * The copyConstructable function can be used as a sort of mixin
 * to implement copy-constructable classes.
 *
 * Why not simply clone the object itself?
 *
 * While cloning is straightforward for data objects,
 * The behavior of class object copying is unpredictable due to function binding.
 * Should a method be copied by value (rebind), or by reference? what if it is a prototype method?
 *
 * For those reasons it can be easier to let the class describe its own copy mechanism via the constructor.
 *
 * @param to
 * @param data
 * @returns {boolean}
 *
 * @example
 *  import { copyConstructable } from 'app/shared/models/copy-constructable';
 *
 *  class DataObject {
 *      public x;
 *      public y;
 *
 *      constructor(data) {
 *          if (copyConstructable(this, data)) {
 *              return;
 *          }
 *          this.x = data.one;
 *          this.y = data.two;
 *      }
 *
 *      copy(): DataObject {
 *        return new DataObject(this);
 *      }
 *
 *  }
 *
 */
export function copyConstructable(to, data): boolean {
  if ((data instanceof to.constructor) as any) {
    for (const key in data) {
      if (data.hasOwnProperty(key)) {
        to[key] = cloneDeep(data[key], false);
      }
    }
    return true;
  }
  return false;
}
